import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import Toggle from 'shared/components/toggle/toggle'
import { trackPageView, googleAnalyticsEvent } from 'shared/util/analytics'
import { giphyGreen } from 'shared/css/colors.css'
import css from './search-type-toggle.css'

@withRouter
class SearchTypeToggle extends PureComponent {
    static propTypes = {
        searchType: PropTypes.string,
        toggleSearchType: PropTypes.func,
    }
    render() {
        const {
            searchType = 'gif',
            toggleSearchType,
            // temp till I can refactor desktop
            setSearchType,
            fetchGifsFromUrl,
            width = 206,
            height = 26,
            term = '',
            isMobile,
            className,
        } = this.props

        const nextSearchType = searchType === 'sticker' ? 'gif' : 'sticker'
        const isStickerMode = nextSearchType === 'sticker'
        const gifUrl = `${term
            .replace(/stickers|sticker|transparent/gi, '')
            .trim()
            .replace(/\s+/g, '-')}`
        const path = `/search/${gifUrl}${isStickerMode ? `-stickers` : ``}${document.location.search}`
        const mainToggle = (
            <Toggle
                toggle={() => {
                    if (isMobile) {
                        setSearchType(nextSearchType)
                        fetchGifsFromUrl(path, { groupId: path })
                    }
                    setTimeout(() => {
                        if (isMobile) {
                            const {
                                history: { replace },
                                location: { state },
                            } = this.props
                            // maintain the same page data
                            replace(path, state)
                        }
                        googleAnalyticsEvent({
                            category: `Search Page`,
                            action: `${nextSearchType} Toggle`,
                            label: term,
                        })
                        trackPageView(path)
                    }, 50)
                }}
                isOn={isStickerMode}
                height={height}
                width={width}
                offColor={giphyGreen}
                onElement={
                    <span className={css.toggleItem} style={{ height }}>
                        GIFs
                    </span>
                }
                offElement={
                    <span className={css.toggleItem} style={{ height }}>
                        Stickers
                    </span>
                }
            />
        )

        if (isMobile) {
            return <div>{mainToggle}</div>
        }

        return (
            <div className={[css.container, className].join(' ')}>
                <Link
                    onClick={() => {
                        toggleSearchType(searchType)
                    }}
                    to={path}
                >
                    {mainToggle}
                </Link>
            </div>
        )
    }
}

export default SearchTypeToggle
